<template>
  <div class="container">
    <div class="w-1200 contetn">
      <div class="top-box">
        <div>
          <el-form ref="form" :model="form" label-width="80px">
            <el-row>
              <el-col :span="8">
                <el-form-item label="CAS" prop="cas">
                  <el-input v-model="form.cas" placeholder="请输入CAS号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="产品名称" prop="product_name">
                  <el-input v-model="form.product_name" placeholder="请输入产品名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" class="flex-end">
                <gradient-button background="#0C60E6" @hit="handleSearch">搜索</gradient-button>
                <gradient-button @hit="handleReset" color="#5F616C" border="1px solid #5F616C"
                                 background="transparent">刷新
                </gradient-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="contetn-box">
        <div class="ter-bars">
          <div class="left-title hit-cursor">
            <div v-for="item in terbars" :key="item.value" :class="[
              'ter-bar-item',
              activeTarBar === item.value ? 'active' : '',
            ]" @click="handleTarBar(item.value)">
              {{ item.label }}({{ item.total || 0 }})
            </div>
          </div>
          <div class="right-add"></div>
        </div>
        <div class="table-box" v-loading="loading">
          <el-table v-if="activeTarBar != '2'" ref="multipleTable" :data="tableData" tooltip-effect="dark"
                    style="width: 100%" border :header-cell-style="{ backgroundColor: '#F6F6F8' }">
            <el-table-column prop="id" width="50" label="序号"></el-table-column>
            <el-table-column prop="cas_no" label="CAS"></el-table-column>
            <el-table-column prop="product_name" label="产品名称">
            </el-table-column>
            <el-table-column prop="province" label="省市区" width="200">
              <template slot-scope="scope">
                <span>{{ scope.row.province }}-{{ scope.row.city }}-{{
                    scope.row.area
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="number" label="数量(单位)">
              <template slot-scope="scope">
                <span>{{ scope.row.number }} {{ scope.row.unit }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="date" label="询价时间" width="200">
              <template slot-scope="scope">
                <span>{{ scope.row.begin_at }} ~ {{ scope.row.end_at }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态">
              <template>
                <el-tag v-if="activeTarBar == '1'" type="success">待报价</el-tag>
                <el-tag v-else-if="activeTarBar == '2'" type="warning">已报价</el-tag>
                <el-tag v-else type="danger">放弃报价</el-tag>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200" v-if="activeTarBar != 3">
              <template slot-scope="scope">
                <div class="operation">
                  <el-button v-if="activeTarBar == 1" @click="handleClick(scope.row)" type="text"
                             size="small">我要报价
                  </el-button>
                  <el-button v-if="activeTarBar == 1" type="text" size="small"
                             @click="handleGiveUp(scope.row)">放弃报价
                  </el-button>
                  <el-button type="text" size="small" @click="handleDetail(scope.row)">详情</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <el-table v-else ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" border
                    :header-cell-style="{ backgroundColor: '#F6F6F8' }">
            <el-table-column prop="id" width="50" label="序号"></el-table-column>
            <el-table-column prop="cas_no" label="CAS"></el-table-column>
            <el-table-column prop="product_name" label="产品名称">
            </el-table-column>
            <el-table-column prop="number" label="询价规格">
              <template slot-scope="scope" v-if="scope.row.purchase">
                <span>{{ scope.row.purchase.number }} {{ scope.row.purchase.unit }}/{{
                    scope.row.purchase.expected_price
                  }}元</span>
              </template>
            </el-table-column>
            <el-table-column prop="number" label="报价规格">
              <template slot-scope="scope">
                <span>{{ scope.row.number }} {{ scope.row.unit }}/{{ scope.row.total_price }}元</span>
              </template>
            </el-table-column>

            <el-table-column prop="date" label="询价时间" width="200">
              <template slot-scope="scope" v-if="scope.row.purchase">
                <span>{{ scope.row.purchase.begin_at }} ~ {{ scope.row.purchase.end_at }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="date" label="报价时间" width="200">
              <template slot-scope="scope">
                <span>{{ scope.row.created_at.split(' ')[0] }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态">
              <template>
                <el-tag v-if="activeTarBar == '1'" type="success">待报价</el-tag>
                <el-tag v-else-if="activeTarBar == '2'" type="warning">已报价</el-tag>
                <el-tag v-else type="danger">放弃报价</el-tag>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200">
              <template slot-scope="scope">
                <div class="operation">
                  <el-button type="text" size="small" @click="handleStatysDetail(scope.row)">详情</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-box">
            <el-pagination class="float-right" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" background
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 我要报价弹窗 -->
    <QuotationAdd :dialogVisible="dialogVisible" @refresh="successFun" @changeDialog="changeDialog"
                  :row="selectRow"></QuotationAdd>
    <!-- 报价管理详情弹窗 -->
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false"
               title="报价管理详情"
               :visible.sync="detailDialogVisible" :before-close="handleCloseDetail" width="50%">

      <div class="detail-content">
        <div v-if="userInfo.member_type==1&&userInfo.vip_status==2">
          升级SVIP会员，解锁完整客户信息
          <el-button type="text" @click="goVip" size="mini">去升级</el-button>
        </div>
        <table class="detail-table" border="1" width="100%" v-loading="detailLoading" v-if="detail">
          <tr>
            <td>CAS编号</td>
            <td>{{ detail.cas_no }}</td>
            <td>产品名称</td>
            <td>{{ detail.product_name }}</td>
          </tr>
          <tr>
            <td>询价开始时间</td>
            <td>{{ detail.begin_at }}</td>
            <td>询价结束时间</td>
            <td>{{ detail.end_at }}</td>
          </tr>
          <tr>
            <td>产品数量</td>
            <td>{{ detail.number }} {{ detail.unit }}</td>
            <td>期望价格</td>
            <td>{{ detail.expected_price }}</td>
          </tr>
          <template v-if="userInfo.vip_status==1&&userInfo.member_type==2">

            <tr v-if="detail.people">
              <td>购买方</td>
              <td>{{ detail.people.company }}</td>
              <td>联系人</td>
              <td>{{ detail.people.realname }}</td>
            </tr>
            <tr v-if="detail.people">
              <td>联系电话</td>
              <td>{{ detail.people.mobile }}</td>
              <td>邮箱</td>
              <td>{{ detail.people.email }}</td>
            </tr>
            <tr>
              <td>省市区</td>
              <td>{{ detail.province }}-{{ detail.city }}-{{ detail.area }}</td>
              <td>发票类型</td>
              <td>{{ detail.invoice_type == 1 ? "专票(13%)" : "普票" }}</td>
            </tr>

          </template>
          <tr v-if="userInfo.vip_status==1&&userInfo.member_type==2">
            <td>备注</td>
            <td colspan="3">
              {{ detail.remark }}
            </td>
          </tr>
        </table>
      </div>
    </el-dialog>
    <!-- 已报价详情管理 -->
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false"
               title="报价管理详情"
               :visible.sync="quoteDialogVisible" :before-close="quoteCloseDetail" width="50%">
      <div class="detail-content">
        <table class="detail-table" border="1" width="100%" v-loading="quoteLoading" v-if="quoteDetail">
          <tr>
            <td>CAS编号</td>
            <td>{{ quoteDetail.cas_no }}</td>
            <td>产品名称</td>
            <td>{{ quoteDetail.product_name }}</td>
          </tr>
          <tr>
            <td>询价时间</td>
            <td v-if="quoteDetail.purchase">{{ quoteDetail.purchase.begin_at + '~' + quoteDetail.purchase.end_at }}</td>
            <td>报价时间</td>
            <td>{{ quoteDetail.created_at }}</td>
          </tr>
          <tr>
            <td>询价重量</td>
            <td v-if="quoteDetail.purchase"> {{ quoteDetail.purchase.number }} {{ quoteDetail.purchase.unit }}</td>
            <td>期望价格</td>
            <td v-if="quoteDetail.purchase">{{ quoteDetail.purchase.expected_price }}</td>
          </tr>
          <tr>
            <td>报价规格</td>
            <td> {{ quoteDetail.number || '--' }} {{ quoteDetail.unit }} / {{ quoteDetail.purity || '--' }}%
              (重量/纯度)
            </td>
            <td>报价价格</td>
            <td>{{ quoteDetail.total_price }}</td>
          </tr>
          <template v-if="is_vip&&userInfo.member_type==2&&quoteDetail.purchase">
            <tr>
              <td>备注</td>
              <td colspan="3">{{ quoteDetail.remark }}</td>
            </tr>
            <tr>
              <td>联系人</td>
              <td>{{ quoteDetail.purchase.people.realname }}</td>
              <td>联系电话</td>
              <td v-if="quoteDetail.purchase.people">{{ quoteDetail.purchase.people.mobile }}</td>
            </tr>
            <tr>
              <td>公司名称</td>
              <td v-if="quoteDetail.purchase?.people?.company"> {{ quoteDetail.purchase.people.company.company }}</td>
            </tr>
          </template>
        </table>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import GradientButton from "@/components/button/gradient-button.vue";
import {
  quote_list,
  quote_product,
  give_up_quote,
  quote_detail,
  quote_detail_get,
} from "@/api/modules/user";
import QuotationAdd from "../../../components/addInfo/quotationAdd.vue";
import {mapGetters} from "vuex";

export default {
  name: "quotation",

  components: {
    QuotationAdd,
    GradientButton,
  },
  data() {
    return {
      // 报价管理详情
      detailDialogVisible: false,
      detailLoading: false,
      detail: {},
      // 已报价详情管理
      quoteDialogVisible: false,
      quoteLoading: false,
      quoteDetail: {},
      // 报价弹窗
      dialogVisible: false,


      form: {
        cas: "",
        product_name: "",
      },
      tableData: [],
      activeName: "first",
      activeTarBar: "1",
      terbars: [
        {
          label: "待报价",
          value: "1",
          total: 0,
        },
        {
          label: "已报价",
          value: "2",
          total: 0,
        },

        {
          label: "放弃报价",
          value: "3",
          total: 0,
        },
      ],
      page: 1,
      pageSize: 10,
      total: 0,
      // 当前选中的行
      selectRow: {},
      loading: false,
    };
  },
  mounted() {
    // 页面每次激活时调用
    this.activeTarBar = "1"
    this.getList();
    this.getTotal();
  },
  computed: {
    ...mapGetters(['is_vip', "userInfo"]),
    unitList() {
      return this.$store.state.config.unitList
    },
  },
  methods: {
    // 报价成功
    successFun() {
      this.getList();
      this.getTotal();
      this.$emit('getNumberInfo')
      this.$store.dispatch('GET_USER_COUNT');
    },
    getTotal() {
      quote_list({
        status: 1,
      }).then((res) => {
        this.terbars[0].total = res.data.data.total;
      });
      quote_list({
        status: 2,
      }).then((res) => {
        this.terbars[1].total = res.data.data.total;
      });
      quote_list({
        status: 3,
      }).then((res) => {
        this.terbars[2].total = res.data.data.total;
      });
    },
    async handleStatysDetail(row) {
      this.quoteLoading = true
      let res = await quote_detail(row.id)
      this.quoteDetail = res.data.data
      this.quoteDialogVisible = true
      this.quoteLoading = false
    },
    handleReset() {
      this.form = {
        cas: "",
      };
      this.page = 1;
      this.getList();
    },
    handleSearch() {
      this.page = 1;
      this.getList();
    },
    // 验证数字
    validateNumber(rule, value, callback) {
      if (!/^\d+(\.\d+)?$/.test(value) || Number(value) <= 0) {
        callback(new Error("请输入大于零的数字"));
      } else {
        callback();
      }
    },
    changeDialog(e) {
      this.dialogVisible = e
    },
    // 获取报价管理列表
    getList() {
      this.loading = true;
      quote_list({
        page: this.page,
        limit: this.pageSize,
        cas_no: this.form.cas ? this.form.cas.trim() : '',
        product_name: this.form.product_name ? this.form.product_name.trim() : '',
        status: Number(this.activeTarBar),
      }).then((res) => {
        this.tableData = res.data.data.data;
        this.total = res.data.data.total;
        this.loading = false;
      });
    },
    // 关闭报价管理详情弹窗
    handleCloseDetail() {
      this.detailDialogVisible = false;
    },
    // 关闭已报价管理详情弹窗
    quoteCloseDetail() {
      this.quoteDialogVisible = false;
    },
    // 点击分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    handleTarBar(value) {
      this.activeTarBar = value;
      this.page = 1;
      this.getList();
    },
    // 报价管理详情
    handleDetail(row) {
      this.detailLoading = true;
      this.detailDialogVisible = true;
      quote_detail_get(row.id).then((res) => {
        this.detail = res.data.data;
        this.detailLoading = false;
      });
    },
    // 我要报价
    handleClick(row) {
      this.selectRow = row;
      this.dialogVisible = true;
      this.$store.dispatch('GET_USER_COUNT')
      this.$store.dispatch('GET_UNIT_LIST')
    },
    // 关闭报价弹窗
    handleClose() {
      this.dialogVisible = false;
    },
    // 放弃报价
    handleGiveUp(row) {
      this.selectRow = row;
      this.$confirm("确定放弃报价吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        give_up_quote(row.id).then((res) => {
          if (res.data.code == 10000) {
            this.$message.success({
              message: res.data.message,
              duration: 2000,
              offset: 200,
            });
            this.getList();
            this.getTotal();

          } else {
            this.$message.error({
              message: res.data.message,
              duration: 2000,
              offset: 200,
            });
          }
        });
      });

    },
    // 提交报价
    handleSubmit() {
      this.$refs.quoteForm.validate((valid) => {
        if (valid) {
          quote_product(this.selectRow.id, this.quoteForm).then((res) => {
            if (res.data.code == 10000) {
              this.$message.success({
                message: res.data.message,
                duration: 2000,
                offset: 200,
              });
              this.dialogVisible = false;
              this.getList();
              this.$refs.quoteForm.resetFields();
              this.quoteForm.unit = this.unitList[0].label;
              this.quoteForm.is_quote = 1;
            } else {
              this.$message.error({
                message: res.data.message,
                duration: 2000,
                offset: 200,
              });
            }
          });
        }
      });
    },
    // 跳转到VIP页面
    goVip() {
      this.$router.push({path: '/vip/vip'});
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .el-dialog__header {
  border-bottom: 1px solid #e5e5e5;
}

.contetn {
  padding: 0 0 20px;
}

.detail-content {

  .detail-table {
    width: 100%;
    border-collapse: collapse;
    /* 关键：合并边框 */
    border-color: #f3f3f3;

    /* 新增样式规则 */
    td:nth-child(1),
    td:nth-child(3) {
      width: 100px;
      height: 40px;
      background: #f9faff;
      text-align: center;
      line-height: 40px;
      color: #5f616c;
    }

    td:nth-child(2),
    td:nth-child(4) {
      height: 40px;
      line-height: 40px;
      padding-left: 33px;
      border: 1px solid #f3f3f3;
      color: #00112b;
    }
  }
}

.contetn-box {
  ::v-deep .el-tabs__nav-wrap::after {
    border-bottom: 1px solid transparent !important;
  }

  .pagination-box {
    margin-top: 20px;
    text-align: right;
  }

  .table-box {
    // margin-top: 20px;
    padding: 20px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
  }

  .ter-bars {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;

    .left-title {
      line-height: 28px;
      display: flex;
      align-items: center;
      gap: 50px;

      .ter-bar-item {
        font-weight: 400;
        font-size: 18px;
        color: #5f616c;
        border-bottom: 4px solid transparent;
      }

      .active {
        font-weight: bold;
        font-size: 18px;
        color: #00112b;
        border-bottom: 4px solid #1890ff;
      }
    }
  }
}

.top-box {
  background: #ffffff;
  border-radius: 6px 6px 6px 6px;
  padding: 30px;
  box-sizing: border-box;

  ::v-deep .el-form-item {
    margin-bottom: 0;
  }

  .search-btn {
    width: 120px;
    // height: 50px;
    background: #1890ff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #2979f1;
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    // line-height: 50px;
  }

  .reset-btn {
    width: 120px;
    // height: 50px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #5f616c;
    font-weight: 400;
    font-size: 18px;
    color: #5f616c;
    // line-height: 50px;
    text-align: center;
  }
}
</style>
